<template>
    <Layout ref="pageRef">
    <template v-slot:navigation>
      <Navigation :showMenu="true">

        <template v-slot:title>
          <!-- <router-link class="title" to="/">Samsung Eco-Package</router-link>
           -->
            <span class="title" @click="HomeLink()">
              Samsung Upcycle-Packaging
              <!-- {{ $t("LandingPage.title") }} -->
            </span>
        </template>
      </Navigation>
    </template>
    
      <template v-slot:content>
        <div class="wrapper">
      <h1 class="h1">Page Not Found</h1>
      </div>
     </template>

    <template v-slot:footer>
      <Footer />
    </template>
  </Layout>
</template>

<script>

import Navigation from "../style/Navigation.vue";
import Footer from "../style/Footer.vue";
import Layout from "../style/Layout.vue";



export default {
  components: {
    Navigation,
    Footer,
    Layout,

  },
  data() {
    return {
     };
  },
  created() {
    window.scrollTo(0, 0);
    this.$forceUpdate();

  },
  methods: {
    HomeLink(){
      window.sessionStorage.setItem("introFlag", true)
      this.$router.push('/')
    }
  },
  mounted() {
  },
};
</script>

<style scoped>
.title{
  cursor: pointer;
}
.footer-wrapper {
  background-color: black;
}

.wrapper {
  background-color: black;
  /* margin:auto; */
  margin:auto;
  line-height:1.875;
  letter-spacing:-0.035em;
  max-width: 1200px;
}

.h1{
  margin-top: 128px;
  text-align: left;
}


@media (max-width: 1024px) {
.wrapper{
    max-width: 83.33vw;
    margin:auto;
  }
 .h1{
  margin-top: 70px;
  text-align: left;

}
}
</style>
